import { UI } from "@wwimmo/ui";
import { useContext, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { RootStoreContext } from "src/stores/RootStore";
import { useTranslation } from "react-i18next";
import { TICKET_STATE } from "src/stores/TicketStore";

const AssignOrderButtonBase = () => {
    const { ticketStore, authStore, assignOrderModalStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    const onClickAssignOrderButton = useCallback(() => {
        const ticketReadyForAssignOrderAction = ticketStore.currentTicket?.validateTicketReadyForAssignOrderAction();

        if (ticketReadyForAssignOrderAction) {
            assignOrderModalStore.setIsModalDisplayed(true);
        }
    }, [ticketStore.currentTicket, assignOrderModalStore]);

    const isAssignedToCurrentUser =
        authStore.user?.userid && authStore.user?.userid === ticketStore.currentTicket?.assignedUser?.id;

    return (
        <UI.Button
            label={t("screens.tickets.assign")}
            onClick={onClickAssignOrderButton}
            disabled={
                ticketStore.isEditing ||
                !isAssignedToCurrentUser ||
                ticketStore.currentTicket?.state === TICKET_STATE.NEW
            }
            className="ticket-button"
        />
    );
};

export const AssignOrderButton = Sentry.withProfiler(observer(AssignOrderButtonBase));
